var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVideoFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 -0.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28588",
    "data-name": "Rectangle 28588",
    width: 21,
    height: 19,
    rx: 2,
    transform: "translate(0 0.58)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    id: "Path_140056",
    "data-name": "Path 140056",
    d: "M17.77,10.53,13.567,8.1a.833.833,0,0,0-1.247.722v4.858a.833.833,0,0,0,1.247.722l4.2-2.425a.835.835,0,0,0,0-1.444Z",
    transform: "translate(-4.54 -2.72)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2192",
    "data-name": "Line 2192",
    x2: 20,
    transform: "translate(0.5 15.08)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoFill);
export default __webpack_public_path__ + "static/media/IconVideoFill.c6d9328d94f3b6d18901f553cd8b1348.svg";
export { ForwardRef as ReactComponent };